var pug = require("!../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (i18n, manageraccounts, popUpText) {pug_html = pug_html + "\u003Cdiv class=\"gridPopup type5\" id=\"alertPopUp\"\u003E\u003Cdiv class=\"gridPopup-body\" id=\"popupbody\"\u003E\u003Cdiv class=\"gridPopup-outerBox\" id=\"outergrid\"\u003E\u003Cdiv class=\"gridPopup-close\"\u003E\u003Cdiv" + (" class=\"closeimage spritedimage spritedimagealign clickable\""+" role=\"button\" tabindex=\"0\""+pug.attr("aria-label", popUpText.remove, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
// iterate manageraccounts
;(function(){
  var $$obj = manageraccounts;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var account = $$obj[index];
if (account.link) {
pug_html = pug_html + "\u003Cdiv\u003E\u003Ca" + (pug.attr("href", account.link, true, true)+" target=\"_blank\" rel=\"noopener noreferrer\"") + "\u003E" + (pug.escape(null == (pug_interp = i18n.getString('Format_CustomerNameAndId', account.Name, account.CustomerNumber)) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = i18n.getString('Format_CustomerNameAndId', account.Name, account.CustomerNumber)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (index < manageraccounts.length - 1) {
pug_html = pug_html + "\u003Cdiv class=\"alert-popup__separator\"\u003E\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var account = $$obj[index];
if (account.link) {
pug_html = pug_html + "\u003Cdiv\u003E\u003Ca" + (pug.attr("href", account.link, true, true)+" target=\"_blank\" rel=\"noopener noreferrer\"") + "\u003E" + (pug.escape(null == (pug_interp = i18n.getString('Format_CustomerNameAndId', account.Name, account.CustomerNumber)) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = i18n.getString('Format_CustomerNameAndId', account.Name, account.CustomerNumber)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (index < manageraccounts.length - 1) {
pug_html = pug_html + "\u003Cdiv class=\"alert-popup__separator\"\u003E\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"manageraccounts" in locals_for_with?locals_for_with.manageraccounts:typeof manageraccounts!=="undefined"?manageraccounts:undefined,"popUpText" in locals_for_with?locals_for_with.popUpText:typeof popUpText!=="undefined"?popUpText:undefined));;return pug_html;};
module.exports = template;